import React, { useCallback } from "react";
import styled from "styled-components";
import { useLightboxContext } from "../context";
const _LightboxClose = ({ children, ...props }) => {
    const { close } = useLightboxContext("LightboxClose");
    const closeButtonRef = React.useRef(null);
    const handleKeyUp = useCallback((e) => {
        if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            close();
        }
    }, [close]);
    return (React.createElement("button", { onClick: close, onKeyUp: handleKeyUp, onKeyDown: (e) => e.preventDefault(), ref: closeButtonRef, "aria-roledescription": "close", "data-testid": "close", ...props }, children));
};
export const LightboxClose = styled(_LightboxClose) ``;
//# sourceMappingURL=LightboxClose.js.map